import { render } from "./VueOnlyTest.vue?vue&type=template&id=0dc3631a"
import script from "./VueOnlyTest.vue?vue&type=script&lang=js"
export * from "./VueOnlyTest.vue?vue&type=script&lang=js"

import "./VueOnlyTest.vue?vue&type=style&index=0&id=0dc3631a&lang=css"
script.render = render

export default script